import { Injectable } from '@angular/core';
import { DpFieldButton, DpFieldGroup, DpFieldNumber, DpFieldText, DpFormRow, DpSection, DpSectionForm, DpSectionIcon } from '@docpath/webcomponents';
import { faCog } from '@fortawesome/free-solid-svg-icons';

@Injectable({
    providedIn: 'root'
})
export class NotificationsConfigFormService {

    getSectionForm(): DpSectionForm {
        return new DpSectionForm({
            sections: [this.getFailedJobsNotificationsSection()],
            i18nPrefix: 'failed-jobs.form',
            sectionIcon: new DpSectionIcon(faCog),
            buttons: []
        });
    }

    private getFailedJobsNotificationsSection(): DpSection {
        return new DpSection({
            name: 'config',
            rows: [
                new DpFormRow([
                    new DpFieldGroup({
                        labelColumn: 2,
                        fields: [
                            new DpFieldNumber({ name: 'checkInterval', required: true, min: 5, max: 9999 }),
                            new DpFieldText({ name: 'minutes', disabled: true })
                        ],
                        column: 2
                    }),
                    new DpFieldButton({ name: 'update', click: () => { }, column: 2, labelHidden: true })
                ])
            ]
        });
    }

}
